/**
 * Shared constant for the layout content ID.
 * Used for enabling/disabling scroll functionality across applications.
 * This ID is referenced when manipulating overflow properties during drag operations
 * or other interactions that require disabling scroll.
 */
export const LAYOUT_CONTENT_ID = 'layout-content';
